<template>
  <div>
    <BaseModal>
      <template>
        <v-form ref="brandComponentForm" v-model="valid" lazy-validation>
            <span v-if="itemId === null">
              <v-container class="mx-0 mt-0" fluid>
                <v-row class="mt-10">
                  <v-col cols="12" lg="9" md="9" sm="12" xs="12" class="mt-n10">
                    <v-text-field
                        dense outlined label="Angebot ID (Title)" v-model="editedItem.title"
                    >
                      <template v-slot:prepend>
                        <v-icon
                            color="primary"
                            v-if="editedItem.notion_id != null"
                            @click="onNotion()"
                        >
                          mdi-alpha-n-box-outline
                        </v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-btn
                      class="mt-n7"
                      @click="onFieldChange('title')"
                      :disabled="!editedItem.title || editedItem.title.length === 0"
                  >
                    Create
                  </v-btn>
                </v-row>
              </v-container>
            </span>
          <span v-else>
              <v-container class="mx-0 mt-0" fluid>
                <v-row>
                  <v-col cols="12" lg="9" md="9" sm="6" xs="6">
                    <v-stepper v-model="stepper_list" elevation="0" width="100%">
                    <v-stepper-header>
                      <template v-for="(group, index) in stepper_list">
                        <v-stepper-step
                            :complete="group.active"
                            :step="index + 1"
                            :color="group.color"
                        >
                          {{ group.header }}
                        </v-stepper-step>
                        <v-divider></v-divider>
                      </template>
                      <v-divider></v-divider>
                    </v-stepper-header>
                  </v-stepper>
                  </v-col>
                  <v-col cols="12" lg="3" md="3" sm="6" xs="6" class="mt-3">
                  <BaseColorSelectedField
                      label="Status"
                      v-model="editedItem.status"
                      @change="onFieldChange('status')"
                      :items="statusList"
                  >
                  </BaseColorSelectedField>
                </v-col>
            </v-row>
                <v-row class="mt-10">
                  <v-col cols="12" lg="9" md="9" sm="12" xs="12" class="mt-n10">
                    <v-text-field
                        dense outlined label="Angebot ID (Title)" v-model="editedItem.title"
                        @change="onFieldChange('title')"
                    >
                      <template v-slot:prepend>
                        <v-icon
                            color="primary"
                            v-if="editedItem.notion_id != null"
                            @click="onNotion()"
                        >
                          mdi-alpha-n-box-outline
                        </v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3" md="3" sm="6" xs="6" class="mt-n10">
                    <BaseFormatDateField
                        v-model="editedItem.submission_date"
                        label="Abgabedatum (Submission date)"
                        @change="onFieldChange('submission_date')"
                    />
                  </v-col>

                  <v-col cols="12" lg="3" md="3" sm="6" xs="6" class="mt-n10">
                    <v-autocomplete
                        v-model="editedItem.customer"
                        :items="customerList"
                        :loading="isCustomerLoading"
                        item-text="title"
                        item-value='id'
                        label="Kunde (Customer)"
                        @change="onFieldChange('customer')"
                        placeholder="Start typing to Search"
                        prepend-icon="mdi-database-search"
                        small-chips
                        outlined
                        dense
                        deletable-chips
                        auto-select-first
                        cache-items
                        flat
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" lg="3" md="3" sm="6" xs="6" class="mt-n10">
                    <v-autocomplete
                        v-model="editedItem.variants"
                        @change="onFieldChange('variants')"
                        :items="variantList"
                        :loading="isVariantLoading"
                        item-text="title"
                        item-value='id'
                        label="Variants"
                        placeholder="Start typing to Search"
                        prepend-icon="mdi-database-search"
                        small-chips
                        outlined
                        dense
                        deletable-chips
                        auto-select-first
                        flat
                        multiple
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" lg="3" md="3" sm="6" xs="6" class="mt-n10">
                    <v-checkbox dense outlined label="Eingang bestätigt (receipt_confirmed)"
                                v-model="editedItem.receipt_confirmed"
                                @change="onFieldChange('receipt_confirmed')"
                    />
                  </v-col>
                </v-row>
                <v-progress-linear
                    :active="loading"
                    color="primary"
                    indeterminate
                    rounded
                    height="2"
                ></v-progress-linear>
                <v-divider></v-divider>
                <v-tabs>
                  <v-tab>Common</v-tab>
                  <v-tab>Documents</v-tab>
                  <v-tab>History</v-tab>
                  <v-tab-item>
                    <v-row dense class="mt-5">
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <v-textarea
                            dense outlined label="Description"
                            v-model="editedItem.description"
                            @change="onFieldChange('description')"
                            rows="5"
                            row-height="15"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                        <v-textarea
                            dense outlined label="Hinweis (note)"
                            v-model="editedItem.note"
                            @change="onFieldChange('note')"
                            rows="5"
                            row-height="15"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                        <BaseColorSelectedField
                            multiple
                            label="Auswertung (Evaluation)"
                            v-model="editedItem.evaluation"
                            @change="onFieldChange('evaluation')"
                            :items="evaluationList"
                        >
                        </BaseColorSelectedField>
                      </v-col>
                      <v-col cols="12" lg="3" md="3" sm="6" xs="6">
                        <v-autocomplete
                            v-model="editedItem.editors"
                            @change="onFieldChange('editors')"
                            :items="userList"
                            :loading="isUserLoading"
                            item-text="username"
                            item-value='id'
                            label="Editors"
                            placeholder="Start typing to Search"
                            prepend-icon="mdi-database-search"
                            small-chips
                            outlined
                            dense
                            deletable-chips
                            auto-select-first
                            flat
                            multiple
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <v-autocomplete
                            v-model="editedItem.customer_order"
                            @change="onFieldChange('customer_order')"
                            :items="customerOrderList"
                            :loading="isCustomerOrderLoading"
                            item-text="title"
                            item-value="id"
                            label="Kunden-Aufträge (Customer order)"
                            placeholder="Start typing to Search"
                            prepend-icon="mdi-database-search"
                            chips
                            outlined
                            dense
                            deletable-chips
                            auto-select-first
                            cache-items
                            flat
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <BaseColorSelectedField
                            label="Express"
                            v-model="editedItem.express"
                            @change="onFieldChange('express')"
                            :items="expressList"
                        >
                        </BaseColorSelectedField>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <BaseFormatDateField
                            v-model="editedItem.target_levy"
                            @change="onFieldChange('target_levy')"
                            label="Ziel Abgabe (Target levy)"></BaseFormatDateField>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <v-text-field
                            dense outlined label="Assembly variant"
                            v-model="editedItem.assembly_variant"
                            @change="onFieldChange('assembly_variant')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <v-text-field
                            dense outlined label="Losgröße (Lot size)"
                            v-model="editedItem.lot_size"
                            @change="onFieldChange('lot_size')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <v-text-field
                            dense outlined label="Mat-Faktor (Food factor)"
                            v-model="editedItem.food_factor"
                            @change="onFieldChange('food_factor')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <v-text-field
                            dense outlined label="Gesamtpreise (Total prices)"
                            v-model="editedItem.total_prices"
                            @change="onFieldChange('total_prices')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <BaseColorSelectedField
                            label="Material"
                            v-model="editedItem.material"
                            @change="onFieldChange('material')"
                            :items="materialList"
                        >
                        </BaseColorSelectedField>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <BaseColorSelectedField
                            label="LP Einkauf (LP purchasing)"
                            v-model="editedItem.lp_purchasing"
                            @change="onFieldChange('lp_purchasing')"
                            :items="lp_purchasingList"
                        ></BaseColorSelectedField>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <BaseColorSelectedField
                            label="EMS"
                            v-model="editedItem.ems"
                            @change="onFieldChange('ems')"
                            :items="emsList"
                        >
                        </BaseColorSelectedField>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="6">
                        <BaseColorSelectedField
                            label="Typ (Type)"
                            v-model="editedItem.typ"
                            @change="onFieldChange('typ')"
                            :items="typList"
                        ></BaseColorSelectedField>
                      </v-col>
                      <v-col cols="4" lg="2" md="2" sm="4" xs="4">
                        <v-checkbox
                            dense outlined label="Daten gespeichert (Data saved)"
                            v-model="editedItem.data_saved"
                            @change="onFieldChange('data_saved')"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="4" lg="2" md="2" sm="4" xs="4">
                        <v-checkbox
                            dense outlined label="Richtpreis (Guide price)"
                            v-model="editedItem.guide_price"
                            @change="onFieldChange('guide_price')"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" lg="2" md="2" sm="4" xs="4">
                        <BaseFormatDateField
                            dense outlined label="Erstellt am (Created on)" disabled
                            v-model="editedItem.created_on"
                        >
                        </BaseFormatDateField>
                      </v-col>
                      <v-col cols="12" lg="2" md="2" sm="4" xs="4">
                        <BaseFormatDateField
                            dense outlined label="Zuletzt bearbeitet (Edited on)" disabled
                            v-model="editedItem.edited_on"
                        >
                        </BaseFormatDateField>
                      </v-col>
                      <v-col cols="12" lg="2" md="2" sm="4" xs="4">
                        <v-text-field
                            dense outlined label="Letzter Bearbeiter (Last editor)" disabled
                            v-model="editedItem.last_editor__username">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <BaseStoreFile
                      :storeDocItemId="itemId"
                      :windowHeight="windowHeight - 400"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <BaseHistory
                        :storeDocItemId="itemId"
                        :windowHeight="windowHeight - 400"
                        wsDetail="/ws/quote_history/"
                        wsRestore="/ws/quote_history_restore/"
                    />
                  </v-tab-item>
                </v-tabs>
              </v-container>
          </span>
        </v-form>
      </template>
    </BaseModal>
    <router-view></router-view>
  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapActions, mapGetters, mapMutations} from "vuex";
import {mapFields} from "vuex-map-fields";
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import BaseFormatDateField from "@/components/BaseFormatDateField";
import StoreFileList from "@/components/StoreFile/StoreFileList";
import BaseColorSelectedField from "@/components/BaseColorSelectedField";
import BaseModal from "@/components/Base/BaseModal";
import BaseHistory from "@/components/BaseHistory/BaseHistory";
import BaseStoreFile from "@/components/BaseStoreFile/BaseStoreFile";

export default {
  name: 'QuoteItem',
  props: ['itemId'],

  components: {
    BaseDeleteDialog,
    BaseFormatDateField,
    StoreFileList,
    BaseColorSelectedField,
    BaseModal,
    BaseHistory,
    BaseStoreFile,
  },

  computed: {
    ...mapGetters('Quote', []),
    ...mapFields('Quote', ['itemList', 'editedItem', 'loading', 'searchTermFile']),
    ...mapFields('Customer', {
      'customerList': 'briefItemList',
      'isCustomerLoading': 'briefLoading',
      'searchCustomer': 'searchTerm'
    }),
    ...mapFields('CustomerOrder', {
      'customerOrderList': 'briefItemList',
      'isCustomerOrderLoading': 'briefLoading',
      'searchCustomerOrder': 'searchTerm'
    }),
    ...mapFields('Variant',
        {
          'variantList': 'briefItemList',
          'isVariantLoading': 'briefLoading',
          'searchVariant': 'searchTerm'
        }),
    ...mapFields('User',
        {
          'userList': 'briefItemList',
          'isUserLoading': 'briefLoading',
          'searchUser': 'searchTerm'
        }),
    stepper_list: function () {
      const activeStatus = this.statusList.find(status => status.hasOwnProperty('text') && status.text === this.editedItem.status)
      const groups = this.statusList.filter(status => status.hasOwnProperty('header'))
      // console.log('groups, activeStatus', groups, activeStatus)
      if (activeStatus !== undefined) {
        for (let group of groups) {
          if (group.header === activeStatus.group)
            group.active = true
          else
            group.active = false
        }
      }
      return groups
    },
  },

  methods: {
    ...
        mapActions('Quote', ['fetchItem', 'fetchAddItem', 'fetchSaveItemField']),
    ...
        mapMutations('Quote', ['updateEditedItem']),
    ...
        mapActions('Customer', {"fetchCustomerList": 'fetchBriefItemList'}),
    ...
        mapActions('CustomerOrder', {"fetchCustomerOrderList": 'fetchBriefItemList',}),
    ...
        mapActions('Variant', {"fetchVariantList": 'fetchBriefItemList'}),
    ...
        mapActions('User', {"fetchUserList": 'fetchBriefItemList'}),
    ...
        mapActions('BaseHistoryDetail', {
          "fetchQuoteHistoryItemList": 'fetchItemList',
          "fetchHistoryDetailRefresh": "fetchRefresh",
        }),
    onFieldChange(fieldName) {
      // console.log('onFieldChange', fieldName, this.editedItem[fieldName])
      let fields_dict = {}
      fields_dict[fieldName] = this.editedItem[fieldName]
      this.fetchSaveItemField({
        itemId: this.editedItem.id,
        fields_dict: fields_dict,
      })
    }
    ,
    onCancel() {
      // console.log('onCancel', this.itemId)
      this.$emit('close', this.value)
      if (this.$route.params.itemId != null)
        this.$router.push({name: 'QuoteList'})
    }
    ,
    onSearchCustomer() {
      // console.log('onSearchCustomer', this.searchCustomer)
      // this.fetchCustomerList(this.editedItem.customer)
      this.fetchCustomerList()
    }
    ,
    onSearchCustomerOrder() {
      // console.log('onSearchCustomerOrder', this.searchCustomerOrder)
      this.fetchCustomerOrderList(this.editedItem.customer_order)
    }
    ,
    onSearchVariant() {
      // console.log('onSearchVariant', this.searchVariant)
      this.fetchVariantList()
    }
    ,
    onSearchUser() {
      // console.log('onSearchUser', this.searchUser)
      this.fetchUserList()
    }
    ,
    onNotion() {
      window.open('https://www.notion.so/' + this.editedItem.notion_id.replace(/-/g, ''), '_blank')
    }
    ,
    onResize() {
      console.log('this.$route.meta.showModal', this.$route.meta.showModal)
      if (this.$route.meta.hasOwnProperty('showModal') && this.$route.meta.showModal === true)
        this.windowHeight = (window.innerHeight * 0.8 - 100)
      else
        this.windowHeight = (window.innerHeight - 100)
    },
  }
  ,
  created() {
    window.addEventListener("resize", this.onResize)
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  async mounted() {
    // console.log('mounted', this.itemId)
    window.addEventListener("resize", this.onResize)
    await this.onResize()
    if (this.$route.params.itemId !== null && this.itemId !== null) {
      await this.fetchItem(this.itemId)
    } else
      this.editedItem = {id: null}
    this.fetchCustomerList()
    this.fetchCustomerOrderList()
    this.fetchVariantList()
    this.fetchUserList()
  }
  ,

  watch: {
    editedItem: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (this.itemId === null && newVal !== null && newVal.hasOwnProperty('id') && newVal.id !== null)
          this.$router.push({name: 'QuoteList_QuoteItem', params: {itemId: this.editedItem.id}})
        // console.log('watch editedItem', newVal, oldVal)
      }
    }
  },

  data() {
    return {
      showModal: false,
      windowHeight: 1200,
      valid: true,
      titleRules: [v => !!v || 'Title is required', v => (v && v.length <= 100) || 'Title must be less than 100 characters',],
      expressList: [
        {text: 'Express', color: 'deep-orange lighten-3'},
        {text: 'EILIG', color: 'orange accent-2'},
      ],
      statusList: [
        {header: 'Eingang', active: false, color: 'blue'},
        {text: 'Gesitchtet', color: 'grey lighten-2', group: 'Eingang'},
        {text: 'Vorab-Klärung', color: 'grey lighten-2', group: 'Eingang'},
        {divider: true},
        {header: 'Office', active: false, color: 'green'},
        {text: 'In Bearbeitung', color: 'grey lighten-1', group: 'Office'},
        {text: 'Abgegeben', color: 'amber lighten-4', group: 'Office'},
        {text: 'Wartet auf Info', color: 'pink lighten-4', group: 'Office'},
        {divider: true},
        {header: 'Sales', active: false, color: 'teal'},
        {text: 'Auftrag kommt', color: 'red lighten-5', group: 'Sales'},
        {text: 'Auftrag erteilt', color: 'green lighten-4', group: 'Sales'},
        {text: 'Abgelehnt', color: 'pink lighten-4', group: 'Sales'},
        {text: 'Nicht angeboten', color: 'blue lighten-4', group: 'Sales'},
      ],
      materialList: [
        {text: 'Beistellung', color: 'orange lighten-4'},
        {text: 'Einkauf', color: 'light-green lighten-4'},
        {text: 'n/a', color: 'deep-purple lighten-4'},
        {text: 'Teil-Beistellung', color: 'amber lighten-4'},
      ],
      lp_purchasingList: [
        {text: 'ja', color: 'light-green lighten-4'},
        {text: 'nein', color: 'red lighten-4'},
      ],
      emsList: [
        {text: 'ja', color: 'light-green lighten-4'},
        {text: 'n/a', color: 'deep-purple lighten-4'},
        {text: 'nein', color: 'red lighten-4'},
      ],
      typList: [
        {text: 'Folge', color: 'blue lighten-4'},
        {text: 'Montage', color: 'light-green lighten-4'},
        {text: 'neu', color: 'orange lighten-4'},
        {text: 'Reparatur', color: 'pink lighten-4'},
      ],
      evaluationList: [
        {text: 'neue Version angefragt', color: 'light-green lighten-4'},
        {text: 'Anforderungen zu hoch', color: 'grey lighten-2'},
        {text: 'Angebot zu spät', color: 'grey lighten-2'},
        {text: 'Lieferzeit zu lang', color: 'orange lighten-4'},
        {text: 'Mat-Preis zu hoch', color: 'red lighten-4'},
        {text: 'EMS-Preis zu hoch', color: 'brown lighten-4'},
        {text: 'LP-Preis zu hoch', color: 'pink lighten-4'},
        {text: 'Gesamt-Preis zu hoch', color: 'light-green lighten-4'},
        {text: 'Ungenügende Betreuung', color: 'blue lighten-4'},
        {text: 'Ungenügende Qualität bei dieser Baugruppe', color: 'purple lighten-4'},
        {text: 'War nur ein Vergleichsangebot', color: 'brown lighten-4'},
        {text: 'Projekt gestorben', color: 'purple lighten-4'},
        {text: 'Zurückgezogen (Kunde)', color: 'grey lighten-2'},
        {text: 'Kundendaten unbrauchbar', color: 'purple lighten-4'},
        {text: 'Bleiben beim Bestücker', color: 'red lighten-4'},
        {text: 'Unbekannt', color: 'red lighten-4'},
        {text: 'Liegt auf Eis', color: 'red accent-1'},
        {text: 'aktualisiertes Angebot', color: 'grey lighten-2'},
        {text: 'An Partner gegeben', color: 'light-green lighten-4'},
      ]
    }
  }
}
</script>

<style scoped lang="scss">
</style>
